import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Row, Col } from "antd";
import { isEmpty } from "lodash";

import "./Auth.scss";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");
const lang = isNordicrouting ? "se" : "en"; // Adjust logic here for additional languages

const text = {
  en: {
    createAccount: "Create a FREE account.",
    signUpSeconds: "Sign up in seconds. No credit card required.",
    fullName: "Full Name",
    workEmail: "Work Email",
    invalidEmail: "Invalid Email",
    required: "Required",
    password: "Password",
    invalidPassword: "Invalid password",
    passwordShouldBe: "Password should be:",
    atLeastCharacters: "At least 8 characters long",
    atLeastLowerCase: "At least one lower case",
    atLeastNumber: "At least one number",
    atLeastUpperCase: "At least one upper case",
    agreeTerms: "By signing up, you agree to the",
    terms: "Terms",
    privacyPolicy: "Privacy Policy",
    register: "Register",
    alreadyAccount: "Already have an account?",
    login: "Login",
  },
  se: {
    createAccount: "Skapa ett GRATIS konto.",
    signUpSeconds: "Registrera dig på sekunder. Inget kreditkort krävs.",
    fullName: "Fullständigt namn",
    workEmail: "Arbets-E-post",
    invalidEmail: "Ogiltig e-post",
    required: "Obligatorisk",
    password: "Lösenord",
    invalidPassword: "Ogiltigt lösenord",
    passwordShouldBe: "Lösenordet ska vara:",
    atLeastCharacters: "Minst 8 tecken långt",
    atLeastLowerCase: "Minst en liten bokstav",
    atLeastNumber: "Minst en siffra",
    atLeastUpperCase: "Minst en stor bokstav",
    agreeTerms: "Genom att registrera dig godkänner du",
    terms: "Villkoren",
    privacyPolicy: "Integritetspolicy",
    register: "Registrera",
    alreadyAccount: "Har du redan ett konto?",
    login: "Logga in",
  },
};

const SignUpForm = ({ auth, detailCode, doSignUp }) => {
  const [form] = Form.useForm();
  const [password, setPassword] = useState("");

  useEffect(() => {
    form.setFieldsValue({
      email: detailCode?.email,
    });
  }, [detailCode]);

  const handleSubmit = params => {
    doSignUp({ ...params, inviteCode: auth.inviteCode });
  };

  return (
    <div className={`SignUpForm ${!isEmpty(detailCode) ? "Invite" : ""}`}>
      <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/logo-${isNordicrouting ? "nordicrouting" : "parcelizer"}.svg`} alt="logo" />
          </Link>
        </div>
        {!isEmpty(detailCode) ? (
          <div className="FormHeader">
            <div className="Title">
              {detailCode.userName} has invited you to join {detailCode.companyName} on Parcelizer.
            </div>
            <div className="SubTitle">
              After signing up, you'll be able to see the details and statuses of all orders tagged to your account
            </div>
          </div>
        ) : (
          <div className="FormHeader">
            <div className="Title">{text[lang].createAccount}</div>
            <div className="SubTitle">{text[lang].signUpSeconds}</div>
          </div>
        )}
        <div className="FormContent">
          <Form.Item label={text[lang].fullName} name="name" rules={[{ required: true, message: text[lang].required }]}>
            <Input size="large" placeholder="First and Last" />
          </Form.Item>
          <Form.Item
            label={text[lang].workEmail}
            name="email"
            hasFeedback
            rules={[
              { type: "email", message: text[lang].invalidEmail },
              { required: true, message: text[lang].required },
            ]}>
            <Input disabled={detailCode?.email} size="large" placeholder="name@company.com" />
          </Form.Item>
          <Form.Item
            label={text[lang].password}
            name="password"
            hasFeedback
            rules={[
              { required: true, message: text[lang].required },
              {
                validator(_, value) {
                  if (!value || new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(.{8,})$").test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(text[lang].invalidPassword));
                },
              },
            ]}>
            <Input.Password
              size="large"
              placeholder={text[lang].password}
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Item>
          <div className="HintPassword Invalid">
            <div className="HintTitle">{text[lang].passwordShouldBe}</div>
            <Row>
              <Col span={12}>
                <div className="HintItem">
                  <img src={`/icons/${/.{8,}/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastCharacters}
                </div>
                <div className="HintItem">
                  <img src={`/icons/${/[a-z]/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastLowerCase}
                </div>
              </Col>
              <Col span={12}>
                <div className="HintItem">
                  <img src={`/icons/${/\d/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastNumber}
                </div>
                <div className="HintItem">
                  <img src={`/icons/${/[A-Z]/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastUpperCase}
                </div>
              </Col>
            </Row>
          </div>
          <div className="Terms">
            {text[lang].agreeTerms} <Link to="#">{text[lang].terms}</Link> and{" "}
            <Link to="#">{text[lang].privacyPolicy}</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            {text[lang].register}
          </Button>
        </div>
      </Form>
      <div className="Register">
        {text[lang].alreadyAccount} <Link to="/login">{text[lang].login}</Link>
      </div>
    </div>
  );
};

export default SignUpForm;
